import { render, staticRenderFns } from "./ver.auditoria.vue?vue&type=template&id=37a58af2"
import script from "./ver.auditoria.vue?vue&type=script&lang=js"
export * from "./ver.auditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports